import { TicketIcon } from 'assets/icons'
import { ButtonLoading } from 'components/Buttons'
import { Modal, ModalContent, ModalIcon } from 'components/Modal'
import { useEffect, useState } from 'react'
import FormattedMessage from 'utils/FormattedMessage'
import { useTranslation } from 'utils'

type Props = {
  open: boolean
  printingWaitTime: number
  onClose: () => void
}

export const KioskPrintWaitModal = ({ open, printingWaitTime, onClose }: Props) => {
  const intl = useTranslation()
  const [secondsLeft, setSecondsLeft] = useState(printingWaitTime)

  useEffect(() => {
    if (!open) return
    setSecondsLeft(printingWaitTime)
  }, [open, printingWaitTime])

  useEffect(() => {
    if (!open) return
    if (secondsLeft <= 0) {
      onClose()
      return
    }
    const id = setTimeout(() => setSecondsLeft(s => s - 1), 1000)
    return () => clearTimeout(id)
  }, [open, secondsLeft, onClose])

  return (
    <Modal
      open={open}
      onClose={onClose}
      submitButton={
        <ButtonLoading onClick={onClose}>
          <FormattedMessage id='kiosk.printWaitModal.ok' />
        </ButtonLoading>
      }
    >
      <ModalIcon icon={<TicketIcon className='h-6 w-6' aria-hidden='true' />} />
      <ModalContent
        title={intl({ id: 'kiosk.printWaitModal.title' })}
        description={`${intl({ id: 'kiosk.printWaitModal.description' })} ${secondsLeft} ${intl({ id: 'seconds' })}`}
      />
    </Modal>
  )
}
